import {
	ADD_FOLDER,
	SET_FOLDERS,
	REMOVE_FOLDER,
	UPDATE_FOLDER,
} from '@/actions/types';

const initialState = [];

export default function folderReducer(state = initialState, action) {
	switch (action.type) {
		case ADD_FOLDER:
			return [...state, action.payload];
		case SET_FOLDERS: {
			const { folders = [] } = action.payload;
			// Sort the folders by their title before storing them in the state
			const sortedFolders = folders.sort((a, b) => {
				const titleA = (a.title || '').toString();
				const titleB = (b.title || '').toString();
				return titleA.localeCompare(titleB);
			});
			return sortedFolders;
		}
		case REMOVE_FOLDER:
			return state.filter((folder) => folder._id !== action.payload);
		case UPDATE_FOLDER:
			return state.map((folder) =>
				folder._id === action.payload._id ? action.payload : folder
			);
		default:
			return state;
	}
}
